import { useState, useRef, useEffect } from 'react';
import { useTheme, jsx } from '@emotion/react';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import ChevronIcon from '../../icons/icons/chevronIcon.js';
import { Thumbnails } from './thumbnails/index.js';
import Style from './style.js';
import { keyboardKeys } from '../../constants/keyboardKeys/index.js';

var Accordion = _ref => {
  var {
    borderRadius = 'small',
    children,
    disabled = false,
    isOpen,
    noBorder = false,
    onClick: _onClick,
    rightAlignArrow = false,
    title
  } = _ref;
  var theme = useTheme();
  var [contentHeight, setContentHeight] = useState('0px');
  var contentRef = useRef(null);
  useEffect(() => {
    var nextHeight = isOpen && contentRef.current ? "".concat(contentRef.current.clientHeight, "px") : '0px';

    if (contentHeight !== nextHeight) {
      setContentHeight(nextHeight);
    }
  });

  var handleKeyDown = event => {
    if (!disabled && event.key === keyboardKeys.enter) {
      _onClick(event);
    }
  };

  return jsx(Style.AccordionBox, {
    isOpen: isOpen,
    noBorder: !!noBorder,
    disabled: !!disabled
  }, jsx(Style.TitleWrapper, {
    onClick: event => {
      if (!disabled) {
        _onClick(event);
      }
    },
    borderRadius: borderRadius,
    onKeyDown: handleKeyDown,
    disabled: !!disabled,
    role: "button",
    isOpen: isOpen,
    tabIndex: disabled ? -1 : 0,
    "aria-disabled": !!disabled,
    "aria-expanded": isOpen
  }, jsx(Style.Truncate, null, title), jsx(Style.ArrowWrapper, {
    rightAlign: !!rightAlignArrow
  }, jsx(ChevronIcon, {
    rotate: isOpen ? 90 : 0,
    fill: theme.COLORS.primary
  }))), jsx(Style.ExpansionWrapper, {
    contentHeight: contentHeight,
    "aria-disabled": !!disabled,
    "aria-hidden": !isOpen
  }, jsx("div", {
    ref: contentRef
  }, children)));
};
Accordion.Container = Style.Container;
Accordion.Content = Style.Content;
Accordion.Thumbnails = Thumbnails;
Accordion.Truncate = Style.Truncate;

export { Accordion };
